import { render, staticRenderFns } from "./UnsupportedBankGoodbye.vue?vue&type=template&id=08ec7c86&scoped=true&"
import script from "./UnsupportedBankGoodbye.vue?vue&type=script&lang=js&"
export * from "./UnsupportedBankGoodbye.vue?vue&type=script&lang=js&"
import style0 from "./UnsupportedBankGoodbye.vue?vue&type=style&index=0&id=08ec7c86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ec7c86",
  null
  
)

export default component.exports